import { i as page } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

//
var script = {
  mixins: [page],
  created: function created() {
    this.$xp.history.addHomePage(this.pageData.ID, "/page/".concat(this.pageData.ID), this.pageData.Title, this.pageData.Homepage ? this.pageData.Homepage.ParentID : undefined, this.pageData.Homepage && this.pageData.Homepage.AncestorIDs ? this.pageData.Homepage.AncestorIDs : []); // is added in http
  },
  methods: {
    setAppLang: function setAppLang(lang) {
      window.localStorage.setItem('nfcLangCode', lang.langCode);
      this.$xp.polyglot.setLanguage(lang.langCode, lang.path);
      this.$router.push(lang.url);
    }
  },
  computed: {
    languageMenuItems: function languageMenuItems() {
      var _this = this;

      var items = [];
      this.pageData.LanguageVirtualFolders.forEach(function (item) {
        items.push({
          id: item.ID,
          langName: item.LangName,
          langCode: item.LangCode,
          langId: item.LangID,
          path: item.Path,
          url: '/page/' + (item.PageID ? item.PageID : _this.pageData.NextPageID),
          icon: item.Icon
        });
      });
      return items;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-select-language-page" }, [
    _c(
      "ul",
      { staticClass: "c-select-language-page__list" },
      _vm._l(this.languageMenuItems, function(language) {
        return _c(
          "li",
          { key: language.id, staticClass: "c-select-language-page__item" },
          [
            _c(
              "a",
              {
                staticClass: "c-select-language-page__link",
                attrs: { href: "#", role: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault();
                    return _vm.setAppLang(language)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "c-select-language-page__icon",
                  attrs: {
                    src: language.icon,
                    alt: language.langName,
                    "aria-hidden": "true"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "c-select-language-page__name" }, [
                  _vm._v(_vm._s(language.langName))
                ])
              ]
            )
          ]
        )
      }),
      0
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=XpSelectLanguagePage.js.map
